import { useEffect, useState } from "react";
import { api } from "./api";
import { App } from "./App";
import { Platform } from "./Platform";
import { Public } from "./Public";

/* One bundle, four surfaces.

   Which one to show is decided by the hostname — but by the *server*, not by
   parsing location.hostname here. That keeps the rule in exactly one place, and
   it means a local run on rinu.lvh.me:5173 takes the same code path as
   rinu.toonspeech.com does in production. */

type Surface =
  | { surface: "panel"; tenant: { slug: string; display_name: string } }
  | { surface: "public"; base_domain: string }
  | { surface: "platform" }
  | { surface: "unclaimed"; slug: string };

export function Root() {
  const [surface, setSurface] = useState<Surface | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    api<Surface>("/api/surface").then(setSurface).catch(() => setFailed(true));
  }, []);

  if (failed) {
    return (
      <main className="claim">
        <h1>Cannot reach the server</h1>
        <p className="muted">Try again in a moment.</p>
      </main>
    );
  }

  if (!surface) return null;

  switch (surface.surface) {
    case "panel":
      return <App tenant={surface.tenant} />;
    case "platform":
      return <Platform />;
    case "public":
      return <Public baseDomain={surface.base_domain} />;
    case "unclaimed":
      // A subdomain nobody has claimed, or one that has been suspended. The two
      // are deliberately indistinguishable from out here.
      return (
        <main className="claim">
          <h1>Nothing here yet</h1>
          <p className="muted">
            <code>{surface.slug}</code> doesn't exist.
          </p>
        </main>
      );
  }
}
